import Request from '../utils/request';

const CLEAR_CART_ENDPOINT = '/api/checkout/clear-cart';

export const CheckoutErrorCodes = {
	ClearCart: 'ClearCartApiError'
};

/**
 *
 * Function that calls the clear checkout cart API endpoint.
 *
 * @param {string} [bookingToken] The checkout booking token
 * @param {Function} [errorHandler] Optional error handler function
 * @returns {void} void
 */
export const clearCart = async (bookingToken, errorHandler) => {
	try {
		if (!bookingToken) {
			throw new Error('Missing booking token.');
		}

		const clearCartData = {
			bookingToken
		};

		// TODO: Confirm if we want to use this old request handler
		const cartResponse = await Request.post(CLEAR_CART_ENDPOINT, clearCartData);

		if (cartResponse.success) {
			return;
		} else {
			errorHandler &&
				errorHandler({ message: 'Cart clear was unsuccessful', isSubmissionError: true }, CheckoutErrorCodes.ClearCart);
		}
	} catch {
		errorHandler &&
			errorHandler({ message: 'Unable to clear cart', isSubmissionError: true }, CheckoutErrorCodes.ClearCart);
	}
};
